export const loadVODPlayer = async () => {
  const { VODPlayer } = await import(
    /* webpackChunkName: "widget/vod-player" */
    '@wix/wix-vod-shared/components'
  );

  return VODPlayer;
};
